<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="page-title">Retail Leads Sheetview</h1>
            </div>
            <div class="col-sm-6 pull-right">
                <div class="col-sm-6 pull-right">
                    <span *ngIf="myrole=='1' || myrole=='14'">
                        <div class="col-sm-12 text-right">
                            <p><a href="{{s3url}}crm/sample_retail_import_leads_rev1.csv" target="_blank">Sample CSV for retail Leads</a></p>
                            <p><a class="btn btn-success text-white" (click)="showModal()"><i class="fa fa-file-excel"></i> Import Retail Leads</a></p>
                           </div>
                    </span>
                    <br>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-4 mt-2">
                        <input class="form-control" [(ngModel)]="search" type="text" (keyup)="getRetailLeads(0,perpage)" placeholder="Search" />
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Status" (selectionChange)="getRetailLeads(0,perpage)" [(ngModel)]="status">
                            <mat-option [value]="">Select Status</mat-option>
                            <mat-option [value]="status.id" *ngFor="let status of corporate_lead_status_list">{{status.status_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Circle" (selectionChange)="getRetailLeads(0,perpage)" [(ngModel)]="circle" multiple>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Bds" (selectionChange)="getRetailLeads(0,perpage)" [(ngModel)]="bd" multiple >
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds_list">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Treatment" (selectionChange)="getRetailLeads(0,perpage)" [(ngModel)]="treatment" multiple>
                            <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Payment Mode" (selectionChange)="getRetailLeads(0,perpage)" [(ngModel)]="pmode">
                            <mat-option [value]="">Select Payment Mode</mat-option>
                            <mat-option value="Cash">Cash</mat-option>
                            <mat-option value="Reimbursement">Reimbursement</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-4 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
    
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="getRetailLeads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>

            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hiddenColumns]="hideColumn" [hotId]="id" [colHeaders]="true" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" licenseKey="non-commercial-and-evaluation" [data]="retail_leads" [beforeChange]="onBeforeChange" [autoWrapRow]="false" [autoWrapCol]="false">
                <hot-column data="id" [readOnly]="true" title="ID"></hot-column>
                <hot-column data="glamyo_patient_id" [readOnly]="true" title="Glamyo Patient Id"></hot-column>
                <hot-column data="lead_created_time" [readOnly]="true" title="Lead Created Time"></hot-column>
                <hot-column data="treatment_name" [readOnly]="true" title="Treatment"></hot-column>
                <hot-column data="name" [readOnly]="true" title="Name"></hot-column>
                <hot-column data="mobile" [readOnly]="true" title="Mobile"></hot-column>
                <hot-column data="circle_name" type="dropdown" [source]="sheetCircle" [readOnly]="false" title="Circle"></hot-column>
                <hot-column data="payment_mode" type="dropdown" [source]="payment_mode_drop" [readOnly]="false" title="Payment Mode"></hot-column>
                <hot-column data="bd_email" type="dropdown" [source]="bds" [readOnly]="false" title="Select User"></hot-column>
                <hot-column data="status_name" type="dropdown" [source]="corporate_lead_status" [readOnly]="false" title="Status"></hot-column>
                <!-- <hot-column data="followup_date_format" type="date" dateFormat='MM/DD/YYYY' [readOnly]="false" title="Followup Date"></hot-column> -->
                <hot-column width="500" data="description" [readOnly]="false" title="Description"></hot-column>
                <hot-column data="source_name" [readOnly]="false" title="Lead Source"></hot-column>
                <hot-column data="utm_source" [readOnly]="false" title="Form Lead Source"></hot-column>
                <hot-column data="last_lead_status_name" [readOnly]="true" title="Last Lead Status"></hot-column>
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div> 
       
    </div>

</div>


<!-- The Modal -->
<div class="modal fade" id="myModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Retail Data</h4>
          <button type="button" class="close" (click)="hideModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted_file" type="file" #csvUpload (change)="selectFile($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted_file"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
              <div class="form-group" *ngIf="upload_msg" [innerHTML]="upload_msg">
                  
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
</div>